import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import SplitImageListImagesScreen from "./SplitImageListImagesScreen";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function SplitImagesMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Split Image & Image Splitter" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/split_image", title: "Split Image Online Free" },
    data2: { link: "/split_image", title: "Photo Splitter" },
    data3: {
      link: "/split_image",
      title: "Seperate Image Into Parts, Grid Maker",
    },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Split images online easily. Divide photos into multiple parts or grids quickly with our fast, secure, and easy to use image splitter tool."
      ></meta>
      <meta
        name="keywords"
        content="split image, image splitter, split images online, divide image, cut image online, split photo, image cut tool, photo splitter, split image into parts, image slicing tool, online image splitter, split image grid, split pictures online, image editor online, split image free, grid maker, image grid maker, tilable image split, seperate image into multiple parts,"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <SplitImageListImagesScreen title={title}></SplitImageListImagesScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{
              "image/jpeg": [".jpg", ".jpeg"],
              "image/png": [".png"],
              "image/webp": [".webp"],
              "image/bmp": [".bmp"],
              "image/svg+sml": [".svg"],
            }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Split Image website offers a fast, reliable, and privacy focused solution for dividing images into multiple parts without requiring an internet connection. Designed to work fully offline, this powerful image splitter processes images directly on your device, ensuring complete data security and zero uploads. Whether you need to split a large image into equal sections, divide photos for social media grids, print posters across multiple pages, or separate scanned images, this tool delivers precise results with high quality. Users can also choose optional online access, making it flexible enough to function as a split image online and split photo online tool while still providing the benefits of offline processing. Supporting popular formats such as JPG, PNG, and WebP, the platform works as a dependable photo splitter for personal and professional use. With an intuitive interface and customizable split options like rows, columns, or custom dimensions, users can split images quickly and efficiently. Ideal for designers, students, marketers, and content creators, this image splitter helps save time and improves workflow productivity. If you are looking for a secure split image tool, an easy to use image splitter, or a flexible split image online solution with offline support, this website provides an efficient way to split images effortlessly." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Split",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Split Image Tool"
            why_use={[
              {
                title: "Split Large Images into Smaller Parts",
                description:
                  "Our split image tool allows users to divide large images into smaller sections easily. Using this image splitter or split image online helps manage oversized images efficiently.",
              },
              {
                title: "Ideal for Social Media Grid Layouts",
                description:
                  "This photo splitter is perfect for creating Instagram grids and social media layouts. With a split photo online tool, users can divide one image into multiple posts.",
              },
              {
                title: "Easy Poster and Banner Printing",
                description:
                  "Split image tools allow large posters and banners to be divided into printable sections, making image splitter tools useful for high-quality printing.",
              },
              {
                title: "Offline Processing for Privacy",
                description:
                  "This offline split image solution processes images directly on your device, ensuring privacy without uploading files to a split image online service.",
              },
              {
                title: "Save Time and Reduce Manual Effort",
                description:
                  "Our photo splitter automates image division, eliminating manual cropping and saving time for designers, students, and professionals.",
              },
              {
                title: "Preserve Image Quality",
                description:
                  "Advanced image splitter tools maintain original resolution and clarity while splitting images for professional-quality output.",
              },
              {
                title: "Flexible Image Splitting Options",
                description:
                  "Modern split image tools offer row, column, and custom size options, giving users full control over how images are divided.",
              },
              {
                title: "Supports Multiple Image Formats",
                description:
                  "Split image online and offline tools support JPG, PNG, WebP, and other popular formats for flexible image processing.",
              },
              {
                title: "Useful for Design and Education",
                description:
                  "Designers, marketers, and educators use photo splitter tools for presentations, assignments, and visual content creation.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "What is an image splitter?",
                description:
                  "An image splitter is a tool that divides a single image into multiple smaller sections or segments. It is useful for creating image grids, social media layouts, photo tiles, and individual image pieces for design projects.",
              },
              {
                title: "How can I split an image into multiple segments for free?",
                description:
                  "Open the image splitter on ShivaPDF.com, select your image, choose the number of rows and columns or other available splitting options, and generate the segments. Download the resulting image pieces when processing is complete.",
              },
              {
                title: "Can I split an image offline?",
                description:
                  "Yes, if the image splitter supports local processing, you can divide images on your device without an internet connection after the tool and its required resources have loaded. Offline availability depends on the implementation.",
              },
              {
                title: "Does ShivaPDF upload my image when splitting it?",
                description:
                  "A locally processed image splitter can divide an image directly in your browser without sending it to a server. Check the tool's implementation and privacy policy to confirm whether your images remain on your device.",
              },
              {
                title: "How do I divide an image into a grid?",
                description:
                  "Select your image in the splitter and choose the number of rows and columns for the grid, if supported. The tool divides the image into smaller sections that you can download individually.",
              },
              {
                title: "Can I split an image into 2, 4, or 9 parts?",
                description:
                  "Yes, if the tool allows you to configure rows and columns, you can create common layouts such as 2, 4, or 9 segments. The available number of segments depends on the splitting options provided.",
              },
              {
                title: "Can I split an image into equal parts?",
                description:
                  "An image splitter can divide an image into equal-sized sections when equal splitting is supported. Select the desired number of rows and columns to create a consistent grid.",
              },
              {
                title: "Can I split an image horizontally?",
                description:
                  "Yes, if horizontal splitting is supported, you can divide an image into multiple horizontal sections. This is useful for separating a tall image into smaller strips or panels.",
              },
              {
                title: "Can I split an image vertically?",
                description:
                  "Yes, if vertical splitting is supported, you can divide an image into vertical strips. This can help create image panels, narrow sections, or pieces for a layout.",
              },
              {
                title: "Can I split an image into Instagram grid posts?",
                description:
                  "An image splitter can help prepare a large image for a multi-post social media grid by dividing it into smaller tiles. Choose a suitable grid layout and check the platform's current image dimensions before publishing.",
              },
              {
                title: "Can I split a large photo into smaller tiles?",
                description:
                  "Yes, splitting a large photo into tiles can make it easier to use in collages, layouts, printing projects, or social media designs. Choose the required grid dimensions and review the resulting segments before downloading.",
              },
              {
                title: "Which image formats can I split?",
                description:
                  "Supported formats depend on the image splitter. Common formats include JPG, JPEG, and PNG. Check the file selector to confirm which formats the ShivaPDF tool accepts.",
              },
              {
                title: "Will splitting an image reduce its quality?",
                description:
                  "Splitting an image does not inherently reduce its quality when the segments are extracted from the original image without additional compression or resizing. The final quality also depends on the output format and export settings.",
              },
              {
                title: "Can I split a transparent PNG image?",
                description:
                  "A transparent PNG can be divided into smaller segments if the tool supports PNG files and preserves transparency. Check the downloaded segments to confirm that transparent areas remain intact.",
              },
              {
                title: "Can I choose custom rows and columns?",
                description:
                  "If custom grid settings are available, you can choose the number of rows and columns to control how an image is divided. More rows and columns create more individual segments.",
              },
              {
                title: "Can I split an image into a specific number of pieces?",
                description:
                  "The number of pieces depends on the tool's supported splitting methods. With a configurable grid, the total number of segments is generally the number of rows multiplied by the number of columns.",
              },
              {
                title: "Can I split images on my phone?",
                description:
                  "You can use a mobile-friendly image splitter on a compatible iPhone or Android device if the tool supports mobile browsers. Open ShivaPDF.com, select an image, and use the available splitting controls.",
              },
              {
                title: "Can I split images on Windows or Mac?",
                description:
                  "A browser-based image splitter can work on compatible Windows and Mac computers. Open ShivaPDF.com in a supported browser, select your image, and create the required segments.",
              },
              {
                title: "Can I split an image without installing software?",
                description:
                  "A browser-based image splitter lets you divide images without installing a separate desktop application. The available splitting and download options depend on the tool's supported features.",
              },
              {
                title: "Is ShivaPDF's image splitter free?",
                description:
                  "ShivaPDF provides browser-based tools for common file and image tasks. Check the image splitter page for current availability, image-size limits, supported formats, and any usage restrictions.",
              },
              {
                title: "Can I split an image without creating an account?",
                description:
                  "You may be able to split images without registration if the tool does not require an account. Check the current ShivaPDF page for access requirements and any applicable limits.",
              },
              {
                title: "Why are my split image segments different in size?",
                description:
                  "Segments may differ slightly in dimensions when the original image cannot be divided evenly by the selected number of rows or columns. Choose dimensions that divide evenly into the original image if equal-sized segments are required.",
              },
              {
                title: "How do I download the split image segments?",
                description:
                  "After splitting the image, use the available download controls to save the generated segments. Depending on the tool, you may be able to download individual pieces or a bundled file containing multiple segments.",
              },
              {
                title: "Is it safe to split private images online?",
                description:
                  "For private images, choose a tool with a clear privacy policy and verified local processing if you want files to remain on your device. Avoid uploading sensitive images to services unless you understand how they are handled.",
              },
            ]} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1614646280}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default SplitImagesMain;
